import { createContext } from "react";

export interface FeatureAppConfig {
  globalApi: string;
  inventoryToolBaseUrl: string;
}

export const AppContext = createContext<FeatureAppConfig>({
  globalApi: "https://globalapi.vwtools.ca",
  inventoryToolBaseUrl: "https://www.vw.ca"
});
